import { useEffect, useMemo, useState } from 'react';
import Slider from '../../../../components/Slider';
import './style.scss';
import { Box, Grid, Typography } from '@mui/material';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import { WebsiteConstants } from '../../../../data/Constants';
import Button from '../../../../components/Button';
import OtherDestinations from '../sections/OtherDestinations';
import Parks from '../sections/Parks';
import Hotels from '../sections/Hotels';
import RequestQuote from '../sections/RequestQuote';
import AttractionDialog from '../sections/AttractionDialog';


const Home = () => {
    const { translate } = useLanguageContext();

    const [selectedAttraction, setSelectedAttraction] = useState<any>(undefined);


    useEffect(() => {
        document.getElementById('root')?.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);


    const banners = useMemo(() => {
        return WebsiteConstants.home.banners.map(b => {
            const title = translate(b.title);
            const description = translate(b.description);;

            return <Box className={`slider-item align-${b.align}`} 
                sx={{
                    backgroundImage: `url(${b.wallpaper})`
                }}
            >
                <Box className='slider-text-container'>
                    {
                        title.length > 0 && <Typography variant='body1' className='slider-title'>
                            {title}
                        </Typography>
                    }

                    {
                        description.length > 0 && <Typography variant='body1' className='slider-description'>
                            {description}
                        </Typography>
                    }
                </Box>
            </Box>
        });
    }, [translate]);


    const defaultDestination = WebsiteConstants.otherDestinations[0];
    

    return <>
        <Box className='grid-content-section' id='home'>
            {
                banners.length > 0 && (
                    <Box className={`slider-container ${banners.length > 1 ? 'with-dots' : ''}`}>
                        <Slider 
                            items={banners}
                            // dots={banners.length > 1 ? true : false}
                            properties={{
                                perView: 1,
                                interval: banners.length > 1 ? 10_000 : 0
                            }}
                        />
                    </Box>
                )
            }
        </Box>

        <Box>
            <Grid container className='card-container'>
                {
                    WebsiteConstants.home.cards.map((c, index) => {
                        return <Grid item xl={2.4} lg={5.6} md={5.6} xs={11.2} className={`card-item ${c.className}`} key={index}>
                            <c.Icon className='card-icon' />
                            <Typography className='card-title'>{translate(c.title)}</Typography>
                            <Typography className='card-description'>{translate(c.description)}</Typography>

                            {
                                c.button && <Button 
                                    label={translate(c.button.label)}
                                    onClick={() => window.open(c.button.link)}
                                    className='card-button backgroundcolor-secondary color-white'
                                />
                            }
                        </Grid>;
                    })
                }
            </Grid>
        </Box>

        <Box paddingY={4} />

        <Parks items={defaultDestination.parks} home={true} onClick={item => setSelectedAttraction(item)} />

        <Box paddingY={2} />

        <RequestQuote variant='tickets' />

        <Box paddingY={2} />

        <Hotels items={defaultDestination.hotels} home={true} onClick={item => setSelectedAttraction(item)} />

        <Box paddingY={2} />

        <RequestQuote variant='reservation' />

        <Box paddingY={2} />

        <OtherDestinations />

        <Box paddingY={2} />

        <RequestQuote variant='default' />

        {/* <Box paddingY={6} />

        <Totalizers /> */}

        {/* <Box paddingY={6} /> */}

        <AttractionDialog 
            open={selectedAttraction !== undefined}
            handleClose={() => setSelectedAttraction(undefined)}
            attraction={selectedAttraction}
        />
    </>;
}

export default Home;